import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, theme, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

const container: CSSProperties = {
  position: "relative",
  display: "flex",
  alignItems: "flex-end",
};

const searchField: CSSProperties = {
  width: 20,
  height: 20,
};

const textField: CSSProperties = {
  width: 300,
  margin: "10px 0",
};

const linkButton: CSSProperties = {
  marginLeft: "auto",
  color: greys.slate,
  fontWeight: 600,
};

const empty: CSSProperties = {
  color: theme.textSecondary,
  padding: "12px 0",
};

const list: CSSProperties = {
  position: "relative",
};

export const confirmation = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    fontSize: size.md,
    color: greys.slate,
    paddingTop: size.md,
    paddingBottom: size.md,
  } as CSSProperties,
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  } as CSSProperties,
  check: {
    htmlColor: colors.green.standard,
    style: {
      marginRight: spacing.sm,
    } as CSSProperties,
  },
  h2: {
    color: colors.blueDusk.standard,
    marginBottom: 0,
    flexGrow: 1,
  } as CSSProperties,
};

export const icon = {
  htmlColor: greys.slate,
};

export const close: CSSProperties = {
  ...icon,
  alignSelf: "flex-end",
};

export const styles = {
  container,
  searchField,
  linkButton,
  empty,
  list,
  textField,
};
